import React from "react";
import PropTypes from "prop-types";

import ButtonGroup from "core/ButtonGroup";

import { QUEUE_VIEWS } from "../../../constants";

// styles
import { BatchFilterMenuStyled } from "./styles";

export const BatchFilterMenu = ({ filterData }) => {
    const {
        currentView,
        setActiveView,
        setSavedView,
        activeCount = 0,
        savedCount = 0
    } = filterData;

    return (
        <BatchFilterMenuStyled data-testid="batch-filter-menu">
            <ButtonGroup
                buttons={[
                    {
                        label: `${activeCount} Active`,
                        isActive: currentView === QUEUE_VIEWS.ACTIVE,
                        onClick: setActiveView
                    },
                    {
                        label: `${savedCount} Saved for Later`,
                        isActive: currentView === QUEUE_VIEWS.SAVED,
                        onClick: setSavedView
                    }
                ]}
            />
        </BatchFilterMenuStyled>
    );
};

export default BatchFilterMenu;

const filterDataShape = {
    currentView: PropTypes.oneOf([
        QUEUE_VIEWS.ACTIVE,
        QUEUE_VIEWS.SAVED,
        QUEUE_VIEWS.LARGE_IMAGE
    ]).isRequired,
    setActiveView: PropTypes.func.isRequired,
    setSavedView: PropTypes.func.isRequired,
    activeCount: PropTypes.number,
    savedCount: PropTypes.number
};

BatchFilterMenu.propTypes = {
    filterData: PropTypes.shape(filterDataShape).isRequired
};
